<article class="provider-card">
  <div class="provider-card-header">
    <div class="provider-card-title">
      <span class="provider-rank">#{{ providerResult().rank }}</span>
      <span class="provider-name">{{ providerResult().translatedName }}</span>
    </div>
    <div class="provider-recommendation">
      <span class="provider-recommendation-text" [style.color]="recommendationInfo().color">
        {{ recommendationInfo().textKey | transloco }}
      </span>
    </div>
  </div>

  <div class="provider-card-body">
    <div class="overall-score">
      <div class="overall-chart">
        <p-chart
          type="doughnut"
          [data]="overallChartData()"
          [options]="overallChartOptions"
          class="chart"
        />
        <div class="overall-chart-center">
          <span class="overall-value" [style.color]="overallColor()">
            {{ providerResult().scores.overallPercentage | appNumber: '1.0-0' }}
          </span>
        </div>
      </div>
      <span class="overall-label">
        {{ 'project.steps.overallResults.card.overallScore' | transloco }}
      </span>
      <span class="overall-state" [style.color]="overallColor()">
        {{
          'project.steps.overallResults.card.scoreLabel.' +
            getScoreLabel(providerResult().scores.overallPercentage) | transloco
        }}
      </span>
    </div>

    <div class="phase-scores">
      @for (phase of phaseScores(); track phase.labelKey) {
        <div class="phase-score-item">
          <span class="phase-label">
            {{ phase.labelKey | transloco }}
          </span>
          <app-score-bar [percentage]="phase.percentage" testId="phase-score-bar" />
          <span class="phase-value" [style.color]="getPhaseColor(phase.percentage)">
            {{ phase.percentage | appNumber: '1.0-0' }}
          </span>
          <span class="phase-state" [style.color]="getPhaseColor(phase.percentage)">
            {{
              'project.steps.overallResults.card.scoreLabel.' + getScoreLabel(phase.percentage)
                | transloco
            }}
          </span>
        </div>
      }
    </div>

    <div class="total-cost">
      <span class="total-cost-value">
        {{ totalCost() | appCurrency: totalCostCurrencyData() : 0 : 0 }}
      </span>
      <span class="total-cost-label">
        {{ 'project.steps.overallResults.card.totalCost' | transloco }}
      </span>
    </div>
  </div>
</article>
